<template>
  <Modal
    :show="true"
    size="xs"
    :showCloseButton="false"
    :closeOnBackdrop="false"
    :closeOnEscape="false"
    :zIndex="10060"
  >
    <template #header>
      <h2 class="disposition-header__title">Save Call Disposition</h2>
    </template>
    <template #body>
      <div class="disposition-body">
        <p class="disposition-required__description">
          Please select a disposition for this call before continuing.
        </p>
        <Select
          v-model="selectedDisposition"
          :options="callDispositions"
          placeholder="Choose call disposition"
          label-key="name"
          value-key="id"
          :return-object="true"
        />
      </div>
    </template>
    <template #footer>
      <Button
        variant="primary"
        :disabled="!selectedDisposition || isSaving"
        :loading="isSaving"
        @click="save"
      >
        {{ isSaving ? "Saving..." : "Save Disposition" }}
      </Button>
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import { ref, computed } from "vue";
import { Button, Modal, Select } from "@/components/ui";
import { useCallDispositions, useLogCallLogDetails } from "@/composables/calls";
import { useToast } from "@/composables/ui/useToast";

const props = defineProps<{
  callSid: string;
}>();

const emit = defineEmits<{
  saved: [];
}>();

const $toast = useToast();
const { data: callDispositionsData } = useCallDispositions();
const callDispositions = computed(() => callDispositionsData.value || []);
const { mutateAsync: logCallLogDetails } = useLogCallLogDetails();

const selectedDisposition = ref<any>(null);
const isSaving = ref(false);

async function save() {
  if (!selectedDisposition.value) return;
  isSaving.value = true;
  try {
    await logCallLogDetails({
      callSid: props.callSid,
      callDispositionId: selectedDisposition.value.id,
    });
    $toast.success("Call disposition saved.");
    emit("saved");
  } catch (error) {
    $toast.error("Failed to save disposition. Please try again.");
  } finally {
    isSaving.value = false;
  }
}
</script>

<style scoped>
.disposition-header__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1a1a2e;
  letter-spacing: -0.01em;
}

.disposition-body {
  padding: 20px 24px;
}

.disposition-required__description {
  margin: 0 0 12px 0;
  font-size: 0.875rem;
  color: #6b7280;
}
</style>
